jQuery( document ).ready(function() {
  
  //jQuery('.answer-sec-main').hide();
 
  // On Category Click
  jQuery('.left-cat-section ul li').click(function(){
    jQuery('.left-cat-section ul li').removeClass('active');
    jQuery(this).addClass('active');
  	var catClass = jQuery(this).attr("id");
    
    //Remove Active class from all details div
    jQuery('.faq-ans-sec').removeClass('active');
    
    //Add active Class of that Cat
    jQuery('#'+catClass+'-details').addClass('active');
  })
  
  // On Question Section Click
  jQuery('.single-question-main').click(function(){
    jQuery('.answer-sec-main').removeClass('active');
    
    var skidcurrent = $(this).attr('id');
    if(skidcurrent == 'active-question-id'){
    	jQuery(this).removeAttr('id');

    }else{
      	jQuery('.single-question-main').removeAttr('id');
    	jQuery(this).attr('id', 'active-question-id');
  		jQuery('.answer-sec-main', this).addClass('active');
    }
    
    
  })
  
  
})


